export default function deleteSitePriceReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'DELETE_SITE_PRICE_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'DELETE_SITE_PRICE_ERROR':
            return {...state, ...{ error: action.error }};

        case 'DELETE_SITE_PRICE_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}